export const MAGIFEST_SECTION_CONTAINER =
  'mx-auto max-w-(--breakpoint-xl) px-4 sm:px-6'

export const MAGIFEST_SECTION_SPACING = 'py-12 sm:py-16'

export const MAGIFEST_SECTION_HEADING =
  'text-3xl leading-tight normal-case font-[family-name:var(--font-lora)] sm:text-4xl'

export const MAGIFEST_SECTION_BODY = 'text-lg leading-relaxed'

export const MAGIFEST_BUTTON_CLASS =
  '!rounded-md !bg-[#16a34a] !bg-none !shadow-none before:hidden !transition-colors hover:!scale-100 hover:!bg-[#15803d] hover:!shadow-none active:!scale-100'
